import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useMutation } from 'react-query';
import { useAuth } from 'hooks/useAuth';
import { useSnackbar } from 'notistack';
import { useTranslation } from 'react-i18next';
import SignupFormView from './view';

const SignupForm = ({ onSuccess, postAction, setShowLogin }) => {
  const navigate = useNavigate();
  const { doSignup, doGoogleLogin } = useAuth();
  const { enqueueSnackbar } = useSnackbar();
  const { t } = useTranslation();
  
  const mutation = useMutation(data => doSignup(data), {
    onSuccess: (result, variables) => {
      const enhancedResult = {
        ...result,
        password: variables.password
      };

      if (onSuccess) {
        onSuccess(enhancedResult);
      }
    },
    onError: (error) => {
      if (error.msg && error.msg.email && Array.isArray(error.msg.email)) {
        if (error.msg.email.includes("user with this email address already exists.")) {
          enqueueSnackbar(t('signup.emailAlreadyExists'), { variant: 'error' });
        } else {
          enqueueSnackbar(error.msg.email[0], { variant: 'error' });
        }
      } else if (error.msg) {
        enqueueSnackbar(
          typeof error.msg === 'string' ? error.msg : 'An error occurred during signup', 
          { variant: 'error' }
        );
      } else {
        enqueueSnackbar('An error occurred during signup', { variant: 'error' });
      }
    }
  });

  const handleFormSubmit = (data) => {
    const signupData = { ...data };
    if (postAction && postAction.group) {
      signupData.slug = postAction.group;
      signupData.action = "joinCommunity";
    }
    mutation.mutate(signupData);
  };

  const handleGoogleLogin = async (credentialResponse) => {
    try {
      const googleData = { ...credentialResponse };
      
      if (postAction && postAction.group) {
        googleData.slug = postAction.group;
        googleData.action = "joinCommunity";
      }
      
      await doGoogleLogin(googleData);
      
      if (postAction && postAction?.action === 'addBooking') {
        return;
      }
      navigate('/');
    } catch (error) {
      enqueueSnackbar(t('login.googleError'), { variant: 'error' });
      console.error("Google login error:", error);
    }
  };

  return (
    <SignupFormView
      onSubmit={handleFormSubmit}
      onGoogleLogin={handleGoogleLogin}
      isLoading={mutation.isLoading}
      setShowLogin={setShowLogin}
    />
  );
};

export default SignupForm;